import Marquee from "react-fast-marquee";

const ITEMS = ["TATTOO", "PIERCING", "JOIAS", "ACESSÓRIOS", "DESDE 1998", "JUNDIAÍ/SP"];

export const EditorialMarquee = () => (
  <div className="bg-[#E60000] py-5 border-y border-black/20" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false}>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic font-bold text-white text-2xl sm:text-3xl px-8 whitespace-nowrap">
            {item}
          </span>
          <span className="w-2 h-2 bg-white rotate-45 inline-block" />
        </span>
      ))}
    </Marquee>
  </div>
);
